import { computed, inject } from '@angular/core';
import { ApiService } from '@libs/core/base-config';
import { AsyncState, asResult, computedFailure, initialState, loadingState } from '@libs/core/lib/state/async-states';
import { getUserWallet } from '@libs/mtjr/shared/generated/entities/wallet/service/wallet.service';
import { Dtos } from '@libs/mtjr/shared/generated/types';
import { patchState, signalStoreFeature, withComputed, withMethods, withState } from '@ngrx/signals';

export function withGetUserWallet() {
  return signalStoreFeature(
    withState<{ getUserWalletState: AsyncState<Dtos.Wallet> }>({
      getUserWalletState: initialState(),
    }),

    withMethods((store, apiService = inject(ApiService)) => ({
      async getUserWallet(queryParams: Dtos.GetUserWalletQueryParams) {
        patchState(store, { getUserWalletState: loadingState() });
        const result = await asResult(getUserWallet(apiService, queryParams));
        patchState(store, { getUserWalletState: result });
      },
    })),
    withComputed((store) => ({
      getUserWalletLoading: computed(() => store.getUserWalletState().type === 'loading'),
      getUserWalletFailure: computedFailure(store.getUserWalletState),
    })),
  );
}
